module.exports = __webpack_public_path__ + "static/swap-btc-tkl-85f2b30cdfcb3408cc3fa770b7330f65.svg";